import Common from './utils-common';

export default {
    setItem(key, val, eff) {
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
            Common.setCookie(key, val, eff);
        }
        else {
            localStorage.setItem(key, val);
        }
    },
    getItem(key) {
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
            Common.getCookie(key);
        }
        else {
            return localStorage.getItem(key);
        }
    },
    removeItem(key) {
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
            Common.removeCookie(key);
        }
        else {
            localStorage.removeItem(key);
        }
    }
}